import type { FeatureConfig } from '@platform/client/features';

import { hasAnyRequiredProperty } from '@packages/utils/has-any-required-property';

import DeviceListPage from './assets/device-list/device-list.page';
import { AssetsFeatureGuard } from './components/assets-feature-guard/assets-feature-guard';
import i18n from './locales/i18n';

export default {
  routes: [
    {
      path: 'assets',
      element: <AssetsFeatureGuard />,
      children: [
        {
          lazy: () =>
            import('./assets/device-list/asset-type-layout/asset-type-layout'),
          children: [
            {
              path: 'devices?',
              element: <DeviceListPage />,
            },
          ],
        },
        {
          path: 'devices/:assetId',
          lazy: () =>
            import(
              './assets/asset-profile/asset-profile-layout/asset-profile-layout'
            ),
          children: [
            {
              path: 'details?',
              lazy: () =>
                import(
                  './assets/asset-profile/asset-details-devices/asset-details-devices.page'
                ),
            },
          ],
        },
      ],
    },
  ],
  navigation: ({ legacyCapabilities, featureFlags }) => {
    const assetsCapabilities = featureFlags?.ADS_GA_RELEASE
      ? { canAccessManageRisk: true }
      : { assets: true };

    const canViewAssets =
      legacyCapabilities &&
      hasAnyRequiredProperty<
        { canAccessManageRisk: boolean } | { assets: boolean }
      >(assetsCapabilities, legacyCapabilities);

    return {
      dataCollection: {
        assets: canViewAssets
          ? {
              title: i18n.t('ads:assets'),
              segment: '/assets',
            }
          : null,
      },
    };
  },
} satisfies FeatureConfig;
